import useRelatedRefinementList from './custom/useRelatedRefinementList';

import InstantSearchAccordion from './units/instantSearchAccordion';
import InstantSearchFilterOption from './units/instantSearchFilterOption';
import { FilterBaseProps } from '../../types/InstantSearch';
import useModal from '@javascript/lib/hooks/useModal';
import AdditionalMakesFilter from './additionalMakesFilter';

const MakeFilter = ({ filtersOpen }: FilterBaseProps) => {
  const { items, refine } = useRelatedRefinementList({
    attribute: 'makeModel.make',
    relatedAttributes: ['makeModel.model', 'makeModel.variant'],
  });

  const { items: models } = useRelatedRefinementList({
    attribute: 'makeModel.model',
    relatedAttributes: [],
  });

  const { ref, openModal, closeModal, maskClickHandlers } = useModal();

  const selectedMakes = items
    .filter((item) => item.isRefined)
    .map((item) => item.escapedValue);

  const modelsSelected = models.some((model) => model.isRefined);

  const selectedOptions = selectedMakes.join(', ');

  return (
    <>
      <InstantSearchAccordion
        filtersOpen={filtersOpen}
        label={'Makes'}
        selectedOptions={selectedOptions}
      >
        <ul>
          {items.map(({ count, name, isRefined, escapedValue }) => (
            <InstantSearchFilterOption.CheckBox
              count={count}
              id={name}
              isSelected={isRefined}
              key={`filter-option__${name}`}
              label={escapedValue}
              onChange={() => refine(escapedValue)}
            />
          ))}
        </ul>
        {modelsSelected && (
          <button
            className="ac-additional-makes__button ch-text--left ch-mt--4 ch-mb--5 ch-ba--0 ch-fs--2 ch-bg--grey-1 ch-pv--2 ch-fw--500 ch-pl--7 ch-width--12"
            data-gtm-track="click_cta"
            data-gtm-track-label="Add more makes to your search"
            onClick={openModal}
            type="button"
          >
            Add more makes to your search
          </button>
        )}
      </InstantSearchAccordion>
      <dialog {...maskClickHandlers} ref={ref}>
        <AdditionalMakesFilter
          closeFilter={closeModal}
          currentSelectedMakes={selectedMakes}
          updateSelectedMakes={refine}
        />
      </dialog>
    </>
  );
};

export default MakeFilter;
